
define('text!Born_Eds/template/summary/eds-discount.html',[],function () { return '<!-- ko if: isDisplayed() -->\n<tr class="totals eds_discount excl">\n    <th class="mark" colspan="1" scope="row" data-bind="text: getLabel()"></th>\n    <td class="amount">\n        <span class="price" data-bind="text: getValue(), attr: {\'data-th\': getLabel()}"></span>\n    </td>\n</tr>\n<!-- /ko -->\n';});

